module.exports = __webpack_public_path__ + "img/icon_success.c11f3121.png";